export enum SupportCategories {
  REQUEST_1_NEW_SERVICE = 'REQUEST_1_NEW_SERVICE',
  REQUEST_2_EXTENDING_SERVICE = 'REQUEST_2_EXTENDING_SERVICE',
  REQUEST_3_CHANGE_PACKAGE = 'REQUEST_3_CHANGE_PACKAGE',
  COMPLAINT_1_QUALITY = 'COMPLAINT_1_QUALITY',
  COMPLAINT_2_EQUIPMENT = 'COMPLAINT_2_EQUIPMENT',
  COMPLAINT_3_CONTRACT = 'COMPLAINT_3_CONTRACT',
  COMPLAINT_4_BILL = 'COMPLAINT_4_BILL'
}
